export const sharedHashCanvasInUseState: {
  current: boolean;
} = {
  current: false,
};
